'use strict';

var nanoid = require('nanoid');
/**
 * Temporary folder
 *
 * @param {function(string): string} transform - Transform function to add prefixes or sufixes to the unique id
 * @returns {string} - Full real path to a temporary folder
 */


var tempdir = function tempdir() {
  var transform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (d) {
    return d;
  };
  return transform(nanoid());
};

module.exports = tempdir;